import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Switch } from '@fluentui/react-components';

export const withUseCampaignSettings = (Component) => {
  const HOC = (props) => {
    const {
      i18n,
      level,
      onLevelChange,
    } = props;

    const useCampaignSettings = useMemo(() => level !== 'adgroup', [level]);

    const onSwitchChange = useCallback((ev, { checked }) => {
      if (checked !== useCampaignSettings) {
        onLevelChange(checked ? 'campaign' : 'adgroup');
      }
    }, [onLevelChange, useCampaignSettings]);

    return (
      <div>
        <Switch
          label={i18n.getString(_TL_('Use campaign settings'))}
          checked={useCampaignSettings}
          onChange={onSwitchChange}
        />
        {useCampaignSettings && <Component readOnly {...props} />}
        {!useCampaignSettings && <Component {...props} />}
      </div>
    );
  };

  HOC.propTypes = {
    i18n: PropTypes.shape({
      getString: PropTypes.func.isRequired,
    }).isRequired,
    level: PropTypes.string.isRequired,
    onLevelChange: PropTypes.func.isRequired,
  };

  HOC.displayName = `withUseCampaignSettings(${Component.displayName || Component.name})`;

  return HOC;
};
